function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getValidElementProps } from '../utils/htmlValidProps';
import Icon from '../Icon';
import '@nt/dds-style/core/button.css';
var propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  /** size of button */
  size: PropTypes.oneOf(['large', 'medium', 'small']),
  /** indicates button kind: primary, secondary, tertiary, borderless */
  kind: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'borderless']),
  /** displays the button in red for possible danger / destructive action */
  danger: PropTypes.bool,
  /** indicates whether the button should have an icon on left, right, none, or only if it's just an icon button without text. Must also pass `iconName` */
  icon: PropTypes.oneOf(['right', 'left', 'none', 'only']),
  /** icon name from Material Icons library */
  iconName: PropTypes.string,
  /** button type can be button, reset or submit */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  noPadding: PropTypes.bool
};
var defaultProps = {
  type: 'button',
  kind: 'primary',
  size: 'small',
  icon: 'none'
};
var Button = React.forwardRef(function (props, ref) {
  var _cx;
  var type = props.type,
    size = props.size,
    kind = props.kind,
    icon = props.icon,
    iconName = props.iconName,
    className = props.className,
    children = props.children,
    disabled = props.disabled,
    onClick = props.onClick,
    noPadding = props.noPadding,
    danger = props.danger;
  var btnProps = getValidElementProps('button', props);
  var iconClass = cx({
    'paddingright-md': icon === 'left',
    'paddingleft-md': icon === 'right'
  });
  var ntClass = cx((_cx = {}, _defineProperty(_cx, "btn--".concat(size), true), _defineProperty(_cx, "btn-skin--".concat(kind), true), _defineProperty(_cx, "btn__icon-".concat(icon), true), _defineProperty(_cx, 'btn--danger', danger), _defineProperty(_cx, "iconNameActive", true), _defineProperty(_cx, 'btn--compact', noPadding && kind === 'borderless'), _cx), className);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: type,
    className: ntClass,
    onClick: onClick,
    disabled: disabled
  }, icon === 'only' && {
    'aria-label': iconName
  }, btnProps, {
    tabIndex: disabled ? -1 : 0,
    ref: ref
  }), icon === 'left' ? /*#__PURE__*/React.createElement(Icon, {
    className: iconClass,
    name: iconName
  }) : null, icon === 'only' ? /*#__PURE__*/React.createElement(Icon, {
    className: iconClass,
    name: iconName,
    ariaHidden: false
  }) : null, icon === 'only' ? null : children, icon === 'right' ? /*#__PURE__*/React.createElement(Icon, {
    className: iconClass,
    name: iconName
  }) : null);
});
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
Button.displayName = 'Button';
Button.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "type": {
      "defaultValue": {
        "value": "'button'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'button'",
          "computed": false
        }, {
          "value": "'reset'",
          "computed": false
        }, {
          "value": "'submit'",
          "computed": false
        }]
      },
      "required": false,
      "description": "button type can be button, reset or submit"
    },
    "kind": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }, {
          "value": "'tertiary'",
          "computed": false
        }, {
          "value": "'borderless'",
          "computed": false
        }]
      },
      "required": false,
      "description": "indicates button kind: primary, secondary, tertiary, borderless"
    },
    "size": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'large'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'small'",
          "computed": false
        }]
      },
      "required": false,
      "description": "size of button"
    },
    "icon": {
      "defaultValue": {
        "value": "'none'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'right'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'none'",
          "computed": false
        }, {
          "value": "'only'",
          "computed": false
        }]
      },
      "required": false,
      "description": "indicates whether the button should have an icon on left, right, none, or only if it's just an icon button without text. Must also pass `iconName`"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "danger": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "displays the button in red for possible danger / destructive action"
    },
    "iconName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "icon name from Material Icons library"
    },
    "noPadding": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};
export default Button;